module.exports = __webpack_public_path__ + "media/images/ecalls/05_market_signs_enfoque_bg-499020bf3ad7ab1059acd9369643f080.png";